import { useState } from "react";

export const usePostImages = (props) => {
  const [imageModal, setImageModal] = useState(false);
  const files = props.images;
  const toggleImageModal = () => {
    setImageModal(!imageModal);
  };

  const [current, setCurrent] = useState(0);

  const handleNext = () => {
    if (files?.length > 1) {
      if (files[current + 1]) {
        setCurrent((prev) => prev + 1);
      } else {
        setCurrent(0);
      }
    }
  };

  const handlePrev = () => {
    if (files?.length > 1) {
      if (files[current - 1]) {
        setCurrent((prev) => prev - 1);
      } else {
        setCurrent(files.length - 1);
      }
    }
  };

  return {
    toggleImageModal,
    imageModal,
    current,
    handleNext,
    handlePrev,
    files,
  };
};
